import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';

import { Context } from './StockManagerContext.jsx';
import { Table } from 'react-bootstrap';
import { shouldSplitOrders } from '../private/permissions.js';

export default function AddToShipmentModal({ isActive, product, onHide }) {
    const { orders, currentUser } = useContext(Context);

    const { userRole } = currentUser || {};
    const shouldSplit = shouldSplitOrders(userRole);

    const isSerialisedOrForwardOrder = product && (!product.enableQty || product.condition === 'Forward Order');
    const productIsUmbrella = product?.name?.toLowerCase()?.includes('umbrella');

    return <Modal show={isActive} size="xl" style={{}} onHide={onHide}>
        <Modal.Header closeButton>
            <Modal.Title>Add <u>{product?.sku}</u> to Shipment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {product && <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Shipping Address</th>
                        <th>Date Required</th>
                        <th>Warehouse</th>
                        <th>SKUs</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order, idx) => {
                        // Find first warehouse with a code
                        const firstWarehouse = order.orderData.warehouseCode || order.products.map(p => p.warehouseCode).filter(Boolean)?.[0];
                        const isUmbrellaOrder = order.products.filter(p => p.name.toLowerCase().includes('umbrella')).length > 0;

                        const hasSerialisedOrForwardOrderItem = order.products.filter(p => !p.enableQty || p.condition === 'Forward Order').length > 0;

                        const firstProduct = order.products[0];
                        const firstSku = firstProduct.sku;
                        const addr = order.orderData.shippingAddress || {};
                        const addressString = [addr.firstName, addr.lastName, addr.street1, addr.city, addr.postcode].filter(Boolean).join(', ') || '-';
                        return (
                            <tr key={idx}>
                                <td>{addressString}</td>
                                <td>{order.orderData.dateRequired || '-'}</td>
                                <td>{firstWarehouse || '-'}</td>
                                <td>{firstSku}</td>
                                <td>
                                    {shouldSplit && product?.warehouseCode && isUmbrellaOrder !== productIsUmbrella && <>
                                        <em>Umbrella orders need to be split off.</em>
                                    </>
                                        ||
                                        shouldSplit && product?.warehouseCode && firstWarehouse !== product?.warehouseCode && <>
                                            <em>Shipment shipping from different warehouse.</em>
                                        </>
                                        ||
                                        shouldSplit && isSerialisedOrForwardOrder && hasSerialisedOrForwardOrderItem && <>
                                            <em>Shipment already has a serialised item.</em>
                                        </>
                                        ||
                                        <button className="btn btn-primary btn-sm" onClick={async () => {
                                            window.OrderForm.openToOrder(idx, product);
                                            onHide();
                                        } }>Add to this Shipment</button>}
                                </td>
                            </tr>
                        );
                    })}
                    <tr><td colSpan="5" className="text-center"><button className="btn btn-primary btn-sm" onClick={() => {

                        // TODO - Use context instead of global actions here.
                        window.OrderForm.openNewOrder(product);
                        onHide();
                    } }>+ Add new Shipment</button></td></tr>
                </tbody>
            </Table>}
        </Modal.Body>
        <Modal.Footer>

        </Modal.Footer>
    </Modal>;
}
